import { get } from 'lodash-es'
import FILTER_CONSTANTS from '@/js/helper/filter-constants.js'
import { CONSTANTS as MESSAGE_CENTER_CONSTANTS } from '@/js/helper/message-center-constants.js'
import DefaultPage from '@/js/components/routes/DefaultPage.vue'
import { ROUTES } from '@/js/plugins/router/route-names-constants.js'
import { DP_ROLE } from '@/js/helper/dp-usermanagement-constants'
import { scopes as FILTER_SCOPES } from '@/js/helper/settings-filter.js'

const ListPage = () =>
  import(/* webpackChunkName: "ListPage" */ '@/js/components/routes/ListPage.vue')
const DetailPage = () =>
  import(/* webpackChunkName: "DetailPage" */ '@/js/components/routes/DetailPage.vue')
const SkuDetailPage = () =>
  import(/* webpackChunkName: "SkuDetailPage" */ '@/js/components/routes/SkuDetailPage.vue')
const FilterPage = () =>
  import(/* webpackChunkName: "FilterPage" */ '@/js/components/routes/FilterPage.vue')
const MessagePage = () =>
  import(/* webpackChunkName: "MessagePage" */ '@/js/components/routes/MessagePage.vue')
const QuickBuyPage = () =>
  import(/* webpackChunkName: "QuickBuyPage" */ '@/js/components/routes/QuickBuyPage.vue')
const SerialNumberSearchPage = () =>
  import(
    /* webpackChunkName: "SerialNumberSearchPage" */ '@/js/components/routes/SerialNumberSearchPage.vue'
  )
const ComparePage = () =>
  import(/* webpackChunkName: "ComparePage" */ '@/js/components/routes/ComparePage.vue')
const SparepartsPage = () =>
  import(/* webpackChunkName: "SparepartsPage" */ '@/js/components/routes/SparepartsPage.vue')
const CheckoutPage = () =>
  import(/* webpackChunkName: "CheckoutPage" */ '@/js/components/routes/CheckoutPage.vue')
const FavoritesPage = () =>
  import(/* webpackChunkName: "FavoritesPage" */ '@/js/components/routes/FavoritesPage.vue')
const FavoritesPrintPage = () =>
  import(
    /* webpackChunkName: "FavoritesPrintPage" */ '@/js/components/routes/FavoritesPrintPage.vue'
  )
// const ServiceWarrantyPage = () =>
//   import(
//     /* webpackChunkName: "ServiceWarrantyPage" */ '@/js/components/routes/ServiceWarrantyPage.vue'
//   )
// const HubSpotChatPage = () =>
//   import(/* webpackChunkName: "HubSpotChatPage" */ '@/js/components/routes/HubSpotChatPage.vue')

// const HubSpotChangeBrandPage = () =>
//   import(
//     /* webpackChunkName: "HubSpotChangeBrandPage" */ '@/js/components/routes/HubSpotChangeBrandPage.vue'
//   )

const ServiceWarrantyListPage = () =>
  import(
    /* webpackChunkName: "ServiceWarrantyListPage" */ '@/js/components/routes/ServiceWarrantyListPage.vue'
  )
const ServiceWarrantyComponentsPage = () =>
  import(
    /* webpackChunkName: "ServiceWarrantyComponentsPage" */ '@/js/components/routes/ServiceWarrantyComponentsPage.vue'
  )

const ServiceWarrantyBmzPage = () =>
  import(
    /* webpackChunkName: "ServiceWarrantyBmzPage" */ '@/js/components/routes/ServiceWarrantyBmzPage.vue'
  )

const ServiceWarrantyBatteryTranslationComponentsPage = () =>
  import(
    /* webpackChunkName: "ServiceWarrantyBatteryTranslationComponentsPage" */ '@/js/components/routes/ServiceWarrantyBatteryTranslationComponentsPage.vue'
  )

const ServiceWarrantyReturnPage = () =>
  import(
    /* webpackChunkName: "ServiceWarrantyReturnPage" */ '@/js/components/routes/ServiceWarrantyReturnPage.vue'
  )

const ProductAttributesTest = () =>
  import(
    /* webpackChunkName: "ProductAttributesTest" */ '@/js/components/routes/ProductAttributesTest.vue'
  )

const HubspotIframePage = () =>
  import(/* webpackChunkName: "HubspotIframePage" */ '@/js/components/routes/HubspotIframePage.vue')

const UsermanagementPage = () =>
  import(
    /* webpackChunkName: "UsermanagementPage" */ '@/js/components/routes/UsermanagementPage.vue'
  )

const SalesOfficeDealerPage = () =>
  import(
    /* webpackChunkName: "SalesOfficeDealerPage" */ '@/js/components/routes/SalesOfficeDealerPage.vue'
  )
const ParticipateInSales = () =>
  import(
    /* webpackChunkName: "ParticipateInSales" */ '@/js/components/routes/ParticipateInSales.vue'
  )
const EventRegistrationPage = () =>
  import(
    /* webpackChunkName: "EventRegistrationPage" */ '@/js/components/routes/EventRegistrationPage.vue'
  )

// const UsermanagementListPage = () =>
//   import(
//     /* webpackChunkName: "UsermanagementPage" */ '@/js/components/routes/UsermanagementListPage.vue'
//   )

export const routes = [
  {
    ...ROUTES.DEFAULT,
    component: DefaultPage,
  },
  {
    ...ROUTES.FILTER,
    component: FilterPage,
    props: true,
  },
  {
    ...ROUTES[FILTER_CONSTANTS.SCOPE.DEBUG],
    component: ListPage,
    meta: { isSearchList: true, scope: FILTER_CONSTANTS.SCOPE.ALL, perm: DP_ROLE.SHOP_ALL_R.p },
    props: route => {
      return {
        ...route.params,
        scope: FILTER_CONSTANTS.SCOPE.ALL,
      }
    },
  },
  {
    ...ROUTES.PRODUCTS,
    component: ListPage,
    meta: { isSearchList: true, scope: FILTER_CONSTANTS.SCOPE.ALL, perm: DP_ROLE.SHOP_ALL_R.p },
  },
  {
    ...ROUTES[FILTER_CONSTANTS.SCOPE.BIKES],
    component: ListPage,
    meta: {
      isSearchList: true,
      scope: FILTER_CONSTANTS.SCOPE.BIKES,
      perm: FILTER_SCOPES[FILTER_CONSTANTS.SCOPE.BIKES],
    },
    props: route => {
      return {
        ...route.params,
        scope: FILTER_CONSTANTS.SCOPE.BIKES,
      }
    },
  },
  {
    ...ROUTES[FILTER_CONSTANTS.SCOPE.BIKES_ITEMS],
    component: ListPage,
    meta: {
      isSearchList: true,
      scope: FILTER_CONSTANTS.SCOPE.BIKES_ITEMS,
      perm: FILTER_SCOPES[FILTER_CONSTANTS.SCOPE.BIKES],
    },
    props: route => {
      return {
        ...route.params,
        scope: FILTER_CONSTANTS.SCOPE.BIKES_ITEMS,
      }
    },
  },
  {
    ...ROUTES[FILTER_CONSTANTS.SCOPE.ACCESSORIES],
    component: ListPage,
    meta: {
      isSearchList: true,
      scope: FILTER_CONSTANTS.SCOPE.ACCESSORIES,
      perm: FILTER_SCOPES[FILTER_CONSTANTS.SCOPE.ACCESSORIES],
    },
    props: route => {
      return {
        ...route.params,
        scope: FILTER_CONSTANTS.SCOPE.ACCESSORIES,
      }
    },
  },
  {
    ...ROUTES[FILTER_CONSTANTS.SCOPE.CURRENT],
    meta: { perm: DP_ROLE.SHOP_BIKES_R.p },
    redirect: { name: FILTER_CONSTANTS.SCOPE.BIKES },
  },
  {
    ...ROUTES[FILTER_CONSTANTS.SCOPE.OUTLET],
    meta: { perm: DP_ROLE.SHOP_BIKES_R.p },
    redirect: { name: FILTER_CONSTANTS.SCOPE.BIKES },
  },
  {
    ...ROUTES[FILTER_CONSTANTS.SCOPE.ARCHIVE],
    component: ListPage,
    meta: {
      isSearchList: true,
      scope: FILTER_CONSTANTS.SCOPE.ARCHIVE,
      perm: FILTER_SCOPES[FILTER_CONSTANTS.SCOPE.ARCHIVE],
    },
    props: route => {
      return {
        ...route.params,
        scope: FILTER_CONSTANTS.SCOPE.ARCHIVE,
      }
    },
  },
  {
    ...ROUTES[FILTER_CONSTANTS.SCOPE.SERVICE],
    component: ListPage,
    meta: {
      isSearchList: true,
      scope: FILTER_CONSTANTS.SCOPE.SERVICE,
      perm: FILTER_SCOPES[FILTER_CONSTANTS.SCOPE.SERVICE],
    },
    props: route => {
      return {
        ...route.params,
        scope: FILTER_CONSTANTS.SCOPE.SERVICE,
        forceView: 'grid',
      }
    },
  },
  {
    ...ROUTES[FILTER_CONSTANTS.SCOPE.PART_SALE],
    component: ListPage,
    meta: {
      isSearchList: true,
      scope: FILTER_CONSTANTS.SCOPE.PART_SALE,
      perm: FILTER_SCOPES[FILTER_CONSTANTS.SCOPE.PART_SALE],
    },
    props: route => {
      return {
        ...route.params,
        scope: FILTER_CONSTANTS.SCOPE.PART_SALE,
        forceView: 'list',
      }
    },
  },

  {
    ...ROUTES[FILTER_CONSTANTS.SCOPE.ACCESSORIES],
    component: ListPage,
    meta: {
      isSearchList: true,
      scope: FILTER_CONSTANTS.SCOPE.ACCESSORIES,
      perm: FILTER_SCOPES[FILTER_CONSTANTS.SCOPE.ACCESSORIES],
    },
    props: route => {
      return {
        ...route.params,
        scope: FILTER_CONSTANTS.SCOPE.ACCESSORIES,
        forceView: 'grid',
      }
    },
  },
  {
    ...ROUTES.ALL_DETAIL,
    component: DetailPage,
    meta: { scrollToTop: true, scope: FILTER_CONSTANTS.SCOPE.ALL, perm: DP_ROLE.SHOP_ALL_R.p },
    props: route => {
      return {
        ...route.params,
        scope: FILTER_CONSTANTS.SCOPE.ALL,
        listLink: route.params.listLink
          ? route.params.listLink
          : { name: FILTER_CONSTANTS.SCOPE.ALL },
      }
    },
  },
  {
    ...ROUTES.SKU_DETAIL,
    component: SkuDetailPage,
    meta: { scrollToTop: true },
    props: route => {
      return {
        ...route.params,
        redirect: true,
        listLink: route.params.listLink ? route.params.listLink : { name: 'default' },
      }
    },
  },
  {
    ...ROUTES.SKU_DETAIL_WAIT,
    component: SkuDetailPage,
    meta: { scrollToTop: true },
    props: route => {
      return {
        ...route.params,
        redirect: false,
        listLink: route.params.listLink ? route.params.listLink : { name: 'default' },
      }
    },
  },

  /*
    SCOPED detail pages -> set Default params
  */
  {
    ...ROUTES.BIKE_DETAIL,
    component: DetailPage,
    meta: {
      scrollToTop: true,
      scope: FILTER_CONSTANTS.SCOPE.BIKES,
      perm: FILTER_SCOPES[FILTER_CONSTANTS.SCOPE.BIKES],
    },
    // props: true,
    // props: route => ({ productId: route.query.productId }),
    props: route => {
      // console.log(route)
      return {
        ...route.params,
        scope: FILTER_CONSTANTS.SCOPE.BIKES,
        listLink: route.params.listLink
          ? route.params.listLink
          : { name: FILTER_CONSTANTS.SCOPE.BIKES },
        // productId: route.params.productId,
      }
    },
  },
  {
    ...ROUTES.BIKE_DETAIL_SKU,
    component: DetailPage,
    meta: {
      scrollToTop: true,
      scope: FILTER_CONSTANTS.SCOPE.SERVICE,
      perm: FILTER_SCOPES[FILTER_CONSTANTS.SCOPE.BIKES],
    },
    // props: true,
    // props: route => ({ productId: route.query.productId }),
    props: route => {
      // console.log(route)
      return {
        ...route.params,
        scope: FILTER_CONSTANTS.SCOPE.BIKES,
        listLink: route.params.listLink
          ? route.params.listLink
          : { name: FILTER_CONSTANTS.SCOPE.BIKES },
        currentSearch: {
          ...get(route.params, 'currentSearch', {}),
          code: route.params.highlightSku,
        },
      }
    },
  },
  {
    ...ROUTES.SEARCH_SN,
    component: SerialNumberSearchPage,
    props: route => {
      return {
        ...route.params,
      }
    },
    meta: { scrollToTop: true, perm: DP_ROLE.SERVICE_SERVICE_WARRANTY_R.p },
  },
  {
    ...ROUTES.SPAREPART_DETAIL,
    component: DetailPage,
    meta: {
      scrollToTop: true,
      scope: FILTER_CONSTANTS.SCOPE.SERVICE,
      perm: FILTER_SCOPES[FILTER_CONSTANTS.SCOPE.SERVICE],
    },
    // props: true,
    // props: route => ({ productId: route.query.productId }),
    props: route => {
      // console.log(route)
      return {
        ...route.params,
        scope: FILTER_CONSTANTS.SCOPE.SERVICE,
        listLink: route.params.listLink
          ? route.params.listLink
          : { name: FILTER_CONSTANTS.SCOPE.SERVICE },
      }
    },
  },
  {
    ...ROUTES.SPAREPART_DETAIL_SKU,
    component: DetailPage,
    meta: {
      scrollToTop: true,
      scope: FILTER_CONSTANTS.SCOPE.SERVICE,
      perm: FILTER_SCOPES[FILTER_CONSTANTS.SCOPE.SERVICE],
    },
    // props: true,
    // props: route => ({ productId: route.query.productId }),
    props: route => {
      // console.log(route)
      return {
        ...route.params,
        scope: FILTER_CONSTANTS.SCOPE.SERVICE,
        listLink: route.params.listLink
          ? route.params.listLink
          : { name: FILTER_CONSTANTS.SCOPE.SERVICE },
        currentSearch: {
          ...get(route.params, 'currentSearch', {}),
          code: route.params.highlightSku,
        },
      }
    },
  },
  {
    ...ROUTES.ACCESSORY_DETAIL,
    component: DetailPage,
    meta: {
      scrollToTop: true,
      scope: FILTER_CONSTANTS.SCOPE.ACCESSORIES,
      perm: FILTER_SCOPES[FILTER_CONSTANTS.SCOPE.ACCESSORIES],
    },
    // props: true,
    // props: route => ({ productId: route.query.productId }),
    props: route => {
      // console.log(route)
      return {
        ...route.params,
        scope: FILTER_CONSTANTS.SCOPE.ACCESSORIES,
        listLink: route.params.listLink
          ? route.params.listLink
          : { name: FILTER_CONSTANTS.SCOPE.ACCESSORIES },
      }
    },
  },
  {
    ...ROUTES.ACCESSORY_DETAIL_SKU,
    component: DetailPage,
    meta: {
      scrollToTop: true,
      scope: FILTER_CONSTANTS.SCOPE.ACCESSORIES,
      perm: FILTER_SCOPES[FILTER_CONSTANTS.SCOPE.ACCESSORIES],
    },
    // props: true,
    // props: route => ({ productId: route.query.productId }),
    props: route => {
      // console.log(route)
      return {
        ...route.params,
        scope: FILTER_CONSTANTS.SCOPE.ACCESSORIES,
        listLink: route.params.listLink
          ? route.params.listLink
          : { name: FILTER_CONSTANTS.SCOPE.ACCESSORIES },
        currentSearch: {
          ...get(route.params, 'currentSearch', {}),
          code: route.params.highlightSku,
        },
      }
    },
  },
  {
    ...ROUTES.CURRENT_DETAIL,
    meta: { perm: DP_ROLE.SHOP_BIKES_R.p },
    redirect: to => ({ name: ROUTES.BIKE_DETAIL.name, params: to.params }),
    // component: DetailPage,
    // meta: { scrollToTop: true, scope: FILTER_CONSTANTS.SCOPE.CURRENT },
    // // props: true,
    // // props: route => ({ productId: route.query.productId }),
    // props: route => {
    //   // console.log(route)
    //   return {
    //     ...route.params,
    //     scope: FILTER_CONSTANTS.SCOPE.CURRENT,
    //     listLink: route.params.listLink
    //       ? route.params.listLink
    //       : { name: FILTER_CONSTANTS.SCOPE.CURRENT },
    //     // productId: route.params.productId,
    //   }
    // },
  },
  {
    ...ROUTES.CURRENT_DETAIL_SKU,
    meta: { perm: DP_ROLE.SHOP_BIKES_R.p },
    redirect: to => ({ name: ROUTES.BIKE_DETAIL_SKU.name, params: to.params }),
    // component: DetailPage,
    // meta: { scrollToTop: true, scope: FILTER_CONSTANTS.SCOPE.CURRENT },
    // // props: true,
    // // props: route => ({ productId: route.query.productId }),
    // props: route => {
    //   // console.log(route)
    //   return {
    //     ...route.params,
    //     scope: FILTER_CONSTANTS.SCOPE.CURRENT,
    //     listLink: route.params.listLink
    //       ? route.params.listLink
    //       : { name: FILTER_CONSTANTS.SCOPE.CURRENT },
    //     // productId: route.params.productId,
    //     currentSearch: {
    //       ...get(route.params, 'currentSearch', {}),
    //       code: route.params.highlightSku,
    //     },
    //   }
    // },
  },
  {
    ...ROUTES.OUTLET_DETAIL,
    meta: { perm: DP_ROLE.SHOP_BIKES_R.p },
    redirect: to => ({ name: ROUTES.BIKE_DETAIL.name, params: to.params }),
    // component: DetailPage,
    // meta: { scrollToTop: true, scope: FILTER_CONSTANTS.SCOPE.OUTLET },
    // // props: true,
    // // props: route => ({ productId: route.query.productId }),import MessageCenter from '@/js/components/ContentElement/Elements/MessageCenter.vue'

    // props: route => {
    //   // console.log(route)
    //   return {
    //     ...route.params,
    //     scope: FILTER_CONSTANTS.SCOPE.OUTLET,
    //     listLink: route.params.listLink
    //       ? route.params.listLink
    //       : { name: FILTER_CONSTANTS.SCOPE.OUTLET },
    //     // productId: route.params.productId,
    //   }
    // },
  },
  {
    ...ROUTES.OUTLET_DETAIL_SKU,
    meta: { perm: DP_ROLE.SHOP_BIKES_R.p },
    redirect: to => ({ name: ROUTES.BIKE_DETAIL_SKU.name, params: to.params }),
    // component: DetailPage,
    // meta: { scrollToTop: true, scope: FILTER_CONSTANTS.SCOPE.OUTLET },
    // // props: true,
    // // props: route => ({ productId: route.query.productId }),import MessageCenter from '@/js/components/ContentElement/Elements/MessageCenter.vue'

    // props: route => {
    //   // console.log(route)
    //   return {
    //     ...route.params,
    //     scope: FILTER_CONSTANTS.SCOPE.OUTLET,
    //     listLink: route.params.listLink
    //       ? route.params.listLink
    //       : { name: FILTER_CONSTANTS.SCOPE.OUTLET },
    //     currentSearch: {
    //       ...get(route.params, 'currentSearch', {}),
    //       code: route.params.highlightSku,
    //     },
    //   }
    // },
  },
  {
    ...ROUTES.ARCHIVE_DETAIL_OLD,
    meta: { perm: DP_ROLE.SHOP_ARCHIVE_R.p },
    redirect: to => ({ name: ROUTES.ARCHIVE_DETAIL.name, params: to.params }),
  },
  {
    ...ROUTES.ARCHIVE_DETAIL_SKU_OLD,
    meta: { perm: DP_ROLE.SHOP_ARCHIVE_R.p },
    redirect: to => ({ name: ROUTES.ARCHIVE_DETAIL_SKU.name, params: to.params }),
  },
  {
    ...ROUTES.ARCHIVE_DETAIL,
    component: DetailPage,
    meta: {
      scrollToTop: true,
      scope: FILTER_CONSTANTS.SCOPE.ARCHIVE,
      perm: FILTER_SCOPES[FILTER_CONSTANTS.SCOPE.ARCHIVE],
    },
    props: route => {
      return {
        ...route.params,
        scope: FILTER_CONSTANTS.SCOPE.ARCHIVE,
        listLink: route.params.listLink
          ? route.params.listLink
          : { name: FILTER_CONSTANTS.SCOPE.ARCHIVE },
      }
    },
  },
  {
    ...ROUTES.ARCHIVE_DETAIL_SKU,
    component: DetailPage,
    meta: {
      scrollToTop: true,
      scope: FILTER_CONSTANTS.SCOPE.ARCHIVE,
      perm: FILTER_SCOPES[FILTER_CONSTANTS.SCOPE.ARCHIVE],
    },
    props: route => {
      return {
        ...route.params,
        scope: FILTER_CONSTANTS.SCOPE.ARCHIVE,
        listLink: route.params.listLink
          ? route.params.listLink
          : { name: FILTER_CONSTANTS.SCOPE.ARCHIVE },
        currentSearch: {
          ...get(route.params, 'currentSearch', {}),
          code: route.params.highlightSku,
        },
      }
    },
  },
  {
    ...ROUTES.SPAREPARTS_SN,
    component: SparepartsPage,
    meta: {
      scrollToTop: true,
      scope: FILTER_CONSTANTS.SCOPE.SERVICE,
      perm: FILTER_SCOPES[FILTER_CONSTANTS.SCOPE.SERVICE],
    },
    // props: true,
    // props: route => ({ productId: route.query.productId }),
    props: route => {
      // console.log(route)
      return {
        ...route.params,
        scope: FILTER_CONSTANTS.SCOPE.SERVICE,
        listLink: route.params.listLink
          ? route.params.listLink
          : { name: FILTER_CONSTANTS.SCOPE.SERVICE },
        // productId: route.params.productId,
      }
    },
  },
  {
    ...ROUTES.SPAREPARTS_SKU,
    component: SparepartsPage,
    meta: {
      scrollToTop: true,
      scope: FILTER_CONSTANTS.SCOPE.SERVICE,
      perm: FILTER_SCOPES[FILTER_CONSTANTS.SCOPE.SERVICE],
    },
    // props: true,
    // props: route => ({ productId: route.query.productId }),
    props: route => {
      // console.log(route)
      return {
        ...route.params,
        scope: FILTER_CONSTANTS.SCOPE.SERVICE,
        listLink: route.params.listLink
          ? route.params.listLink
          : { name: FILTER_CONSTANTS.SCOPE.SERVICE },
        // productId: route.params.productId,
      }
    },
  },
  {
    ...ROUTES.MESSAGE_CENTER_LIST,
    component: MessagePage,
    meta: { scrollToTop: true, perm: DP_ROLE.MESSAGING_ACCESS_R.p },
    props: route => {
      return {
        ...route.params,
        scope: route.params.scope ? route.params.scope : MESSAGE_CENTER_CONSTANTS.MESSAGE_CENTER,
        listLink: route.params.listLink
          ? route.params.listLink
          : { name: MESSAGE_CENTER_CONSTANTS.MESSAGE_CENTER },
      }
    },
  },
  {
    ...ROUTES.QUICK_BUY,
    component: QuickBuyPage,
    meta: { scrollToTop: true, perm: DP_ROLE.SHOP_ORDER_R.p },
  },
  {
    ...ROUTES.COMPARE,
    component: ComparePage,
    meta: { scrollToTop: true, perm: DP_ROLE.SHOP_COMPARE_R.p },
  },
  {
    ...ROUTES.PRODUCT_ATTRIBUTES,
    component: ProductAttributesTest,
    meta: { scrollToTop: true, perm: DP_ROLE.SHOP_ALL_R.p },
  },
  {
    ...ROUTES.CHECKOUT,
    component: CheckoutPage,
    meta: { scrollToTop: true, perm: DP_ROLE.SHOP_ORDER_R.p },
  },
  {
    ...ROUTES.FAVORITES,
    component: FavoritesPage,
    meta: { scrollToTop: true, hideHeader: true, perm: DP_ROLE.SHOP_FAVORITES_R.p },
    props: route => {
      return {
        ...route.params,
        backLink: route.params.backLink ? route.params.backLink : { name: 'default' },
      }
    },
  },
  {
    ...ROUTES.FAVORITES_PRINT,
    component: FavoritesPrintPage,
    meta: { scrollToTop: true, hideHeader: true, perm: DP_ROLE.SHOP_FAVORITES_R.p },
    props: route => {
      return {
        ...route.params,
        backLink: route.params.backLink ? route.params.backLink : { name: 'default' },
      }
    },
  },
  // {
  //   path: '/service-warranty',
  //   name: 'service-warranty',
  //   component: ServiceWarrantyPage,
  //   meta: { scrollToTop: true, perm: DP_ROLE.SERVICE_SERVICE_WARRANTY_R.p },
  //   props: route => {
  //     return {
  //       ...route.params,
  //       backLink: route.params.backLink ? route.params.backLink : { name: 'default' },
  //     }
  //   },
  // },
  // {
  //   path: '/hubspot-change-brand',
  //   name: 'hubspot-change-brand',
  //   component: HubSpotChangeBrandPage,
  //   meta: { scrollToTop: true },
  // },
  // {
  //   path: '/hubspot-chat/:brand',
  //   name: 'hubspot-chat-page',
  //   component: HubSpotChatPage,
  //   meta: { scrollToTop: true },
  //   props: route => {
  //     return {
  //       ...route.params,
  //     }
  //   },
  // },
  // eslint-disable-next-line spaced-comment
////////////////////////////////////////////
///
///////////////////////////////////
//////////////////////////////////
///////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
/////////////////////
//////////////
////////////////////////
//////////////////////////////////////////////////////////////////////////////////////
///////
//////
////
///
/////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
/////////////////////
//////////////
////////////////////////
//////////////////////////////////////////////////////////////////////////////////////
///////
//////
////
////////////////////////////////////////////
////////////
  {
    path: '/service-warranty-return/:deliveryNoteId?/:id?',
    name: 'service-warranty-return',
    component: ServiceWarrantyReturnPage,
    meta: {
      scrollToTop: true,
      isServiceBasket: true,
      perm: DP_ROLE.SERVICE_PART_DELIVERY_CLAIM_R.p,
    },
    props: route => {
      return {
        ...route.params,
        backLink: route.params.backLink ? route.params.backLink : { name: 'default' },
      }
    },
  },
  {
    path: '/service-warranty-components/:serialnumber?/:id?',
    name: 'service-warranty-components',
    component: ServiceWarrantyComponentsPage,
    meta: { scrollToTop: true, isServiceBasket: true, perm: DP_ROLE.SERVICE_SERVICE_WARRANTY_R.p },
    props: route => {
      return {
        ...route.params,
        backLink: route.params.backLink ? route.params.backLink : { name: 'default' },
      }
    },
  },
  {
    path: '/service-warranty-battery/:id?',
    name: 'service-warranty-battery',
    component: ServiceWarrantyBmzPage,
    meta: { scrollToTop: true, isServiceBasket: true, perm: DP_ROLE.SERVICE_BATTERY_CHARGER_R.p },
    props: route => {
      return {
        ...route.params,
        backLink: route.params.backLink ? route.params.backLink : { name: 'default' },
      }
    },
  },
  {
    path: '/service-warranty-battery/:type/:id?',
    name: 'service-warranty-battery-type',
    component: ServiceWarrantyBmzPage,
    meta: { scrollToTop: true, isServiceBasket: true, perm: DP_ROLE.SERVICE_BATTERY_CHARGER_R.p },
    props: route => {
      return {
        ...route.params,
        backLink: route.params.backLink ? route.params.backLink : { name: 'default' },
      }
    },
  },
  {
    path: '/knowledgebase/:brand',
    name: 'knowledgebase',
    component: HubspotIframePage,
    meta: { scrollToTop: true, reducedHeight: true },
    props: route => {
      return {
        ...route.params,
      }
    },
  },
  {
    path: '/support-portal/:brand',
    name: 'support-portal',
    component: HubspotIframePage,
    meta: { scrollToTop: true, reducedHeight: true },
    props: route => {
      return {
        ...route.params,
      }
    },
  },

  // {
  //   path: '/service-warranty-engine/:id',
  //   name: 'service-warranty-engine',
  //   component: ServiceWarrantyComponentsPage,
  //   meta: { scrollToTop: true },
  //   props: route => {
  //     return {
  //       ...route.params,
  //       backLink: route.params.backLink ? route.params.backLink : { name: 'default' },
  //     }
  //   },
  // },
  {
    ...ROUTES.USERMANAGEMENT,
    component: UsermanagementPage,
    meta: { scrollToTop: true, perm: DP_ROLE.ACCOUNT_USER_SUBUSER_R.p },
    props: route => {
      return {
        ...route.params,
        backLink: route.params.backLink ? route.params.backLink : { name: 'default' },
      }
    },
  },
  {
    ...ROUTES.DEALER_BY_SALES_ORG,
    component: SalesOfficeDealerPage,
    meta: { scrollToTop: true, perm: DP_ROLE.ACCOUNT_USER_SALES_OFFICE_R.p },
    props: route => {
      return {
        ...route.params,
        backLink: route.params.backLink ? route.params.backLink : { name: 'default' },
      }
    },
  },
  {
    ...ROUTES.SET_SALES_GROUP,
    component: ParticipateInSales,
    meta: { scrollToTop: true, perm: DP_ROLE.ACCOUNT_USER_SELF_W.p },
    props: route => {
      return {
        ...route.params,
        backLink: route.params.backLink ? route.params.backLink : { name: 'default' },
      }
    },
  },
  {
    ...ROUTES.EVENT_REGISTRATION,
    component: EventRegistrationPage,
    meta: { scrollToTop: true },
    props: route => {
      return {
        ...route.params,
        backLink: route.params.backLink ? route.params.backLink : { name: 'default' },
      }
    },
  },
  // {
  //   ...ROUTES.USERMANAGEMENTLIST,
  //   component: UsermanagementListPage,
  //   meta: { scrollToTop: true },
  // },
]
